import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StatusBadgeProps {
  status: string;
}

const badgeColorMap: Record<string, { bg: string; color: string }> = {
  AWAITING_MANUAL_ACCEPTANCE: { bg: 'warning.light', color: 'warning.contrastText' },
  READY_TO_PROCESS: { bg: 'info.light', color: 'info.contrastText' },
  CREATED: { bg: '#4CAF50', color: '#fff' },
  PENDING: { bg: '#FFC107', color: '#fff' },
  DONE: { bg: '#BDBDBD', color: '#fff' },
  CANCEL: { bg: '#f44336', color: '#fff' },
  REFUSED: { bg: '#9E9E9E', color: '#fff' },
  ERROR: { bg: '#f44336', color: '#fff' },
};

const BadgeBase = styled(Box)({
  display: 'inline-block',
  padding: '2px 12px',
  borderRadius: 10,
  fontSize: 12,
  fontWeight: 600,
  textAlign: 'center',
  whiteSpace: 'nowrap',
});

const statusLabelMap: Record<string, string> = {
  AWAITING_MANUAL_ACCEPTANCE: 'Aguardando Aceite',
  READY_TO_PROCESS: 'Pronto p/ Processar',
  CREATED: 'Criado',
  PENDING: 'Pendente',
  DONE: 'Deferido',
  CANCEL: 'Cancelado',
  REFUSED: 'Recusado',
  ERROR: 'Erro',
};

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const colors = badgeColorMap[status] ?? { bg: '#BDBDBD', color: '#fff' };
  const label = statusLabelMap[status] ?? status;

  return (
    <BadgeBase
      sx={{
        bgcolor: colors.bg,
        color: colors.color,
      }}
    >
      {label}
    </BadgeBase>
  );
};

export default StatusBadge;
